import { ArrowUpRight, Plus, Check } from "lucide-react";
import { outUrl, eur, itemImage } from "@/lib/api";

export function ProductCard({ p, onAdd, selected }) {
  return (
    <div className="card-lux group overflow-hidden hover:-translate-y-1" data-testid={`product-card-${p.id}`}>
      <div className="relative aspect-[4/5] overflow-hidden bg-[#121215]">
        <img src={itemImage(p)} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <span className="absolute left-3 top-3 rounded-full bg-black/70 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-amber-200/90 backdrop-blur">
          {p.source === "wardrobe" ? "Mein Teil" : p.brand}
        </span>
      </div>
      <div className="space-y-3 p-5">
        <div>
          <p className="text-[11px] uppercase tracking-widest text-neutral-500">{p.category}{p.color_name ? ` · ${p.color_name}` : ""}</p>
          <h3 className="mt-1 font-serif text-xl leading-tight text-[#FAF7F0]">{p.name}</h3>
        </div>
        <div className="flex items-center justify-between gap-2">
          {p.price != null && p.source !== "wardrobe" ? <span className="text-sm font-semibold">{eur(p.price)}</span> : <span className="text-xs text-neutral-500">{p.brand || "Eigenes Teil"}</span>}
          <div className="flex gap-2">
            {onAdd && (
              <button onClick={() => onAdd(p)} className={`flex h-9 w-9 items-center justify-center rounded-full border transition-colors ${selected ? "border-[#D4AF37] bg-[#D4AF37] text-black" : "border-white/15 hover:border-[#D4AF37]"}`} data-testid={`add-to-outfit-${p.id}`} title="Zum Outfit">
                {selected ? <Check className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
              </button>
            )}
            {p.source !== "wardrobe" && p.affiliate_url && (
              <a href={outUrl(p.id)} target="_blank" rel="noopener noreferrer sponsored" className="inline-flex items-center gap-1 rounded-full bg-[#FAF7F0] px-4 py-2 text-xs font-semibold text-black transition-transform hover:scale-[1.03]" data-testid={`affiliate-shop-button-${p.id}`}>
                Zum Shop <ArrowUpRight className="h-3.5 w-3.5" />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
